import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "./components/Layout";
import { ScrollToTop } from "./components/ScrollToTop";
import { MetaPixelRouter } from "./components/MetaPixelRouter";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <MetaPixelRouter />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Quote />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" closeButton />
    </div>
  );
}

export default App;
